var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xy-alert"},[_c('a-alert',{attrs:{"message":"请勿发送业务敏感信息","type":"warning","banner":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }